import { render, staticRenderFns } from "./ShowNotesEvents.vue?vue&type=template&id=599315dc&scoped=true"
import script from "./ShowNotesEvents.vue?vue&type=script&lang=js"
export * from "./ShowNotesEvents.vue?vue&type=script&lang=js"
import style0 from "./ShowNotesEvents.vue?vue&type=style&index=0&id=599315dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599315dc",
  null
  
)

export default component.exports